import { render, staticRenderFns } from "./TenantOwnTermsOfServiceForm.vue?vue&type=template&id=23dc2f4e&"
import script from "./TenantOwnTermsOfServiceForm.vue?vue&type=script&lang=ts&"
export * from "./TenantOwnTermsOfServiceForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports